import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Typography } from '@material-ui/core';
import { email, maxLength, minLength, required, useDataProvider } from 'react-admin';
import { useForm } from 'react-final-form';
import { FormSectionTitle } from '../../../Components/Typography/Headlines';
import FormTextInput from '../../../Components/Inputs/Form/FormTextInput';
import FormDateInput from '../../../Components/Inputs/Form/FormDateInput';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormSelectInput from '../../../Components/Inputs/Form/FormSelectInput';
import { isEmpty } from 'lodash';

const FCA_MIN_LENGTH = 6;
const FCA_MAX_LENGTH = 7;
const useStyles = makeStyles((theme) => ({
    fcaIDInput: {
        '& > .MuiOutlinedInput-adornedEnd': {
            paddingRight: '0',
        },
    },
    fcaIDInputWithHelperText: {
        paddingBottom: '1rem',
    },
    circularProgressContainer: {
        width: 0,
    },
    circularProgress: {
        top: '4px',
        left: '-40px',
        position: 'relative',
    },
}));

export function SwitchFirm() {
    const form = useForm();

    const classes = useStyles();
    const dataProvider = useDataProvider();
    const [loading, setLoading] = useState(false);
    const [firmChoices, setFirmChoices] = useState([]);
    const [fcaError, setFcaError] = useState(false);

    const getFirmsByFcaId = async (e) => {
        const value = e.target.value;

        if (value.length < FCA_MIN_LENGTH) {
            return;
        }

        if (value.length > FCA_MAX_LENGTH) {
            return;
        }

        setLoading(true);
        const res = await dataProvider('GET_LIST', 'professional/firm-fca', { filter: { fcaNumber: value } });
        setLoading(false);

        setFcaError(isEmpty(res.data));

        form.change('new_firm_id', null);
        setFirmChoices(res.data);
    };

    return (
        <div>
            <FormSectionTitle title={'Need to change firm?'}/>
            <NewFirmDetail
                label={'New Firm FCA ID:'}
                source={'new_fca_id'}
                validateFunction={[required(), minLength(FCA_MIN_LENGTH), maxLength(FCA_MAX_LENGTH)]}
                onBlur={getFirmsByFcaId}
                InputProps={{ endAdornment: <LoadingCircularProgress loading={loading}/> }}
                className={`${classes.fcaIDInput} ${fcaError ? '' : classes.fcaIDInputWithHelperText}`}
                helperText={fcaError ? 'Invalid FCA ID' : ''}
            />

            <Grid container direction={'row'} alignContent={'center'}>
                <Grid item xs={12} sm={6} md={2}>
                    <Typography>New Firm name:</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormSelectInput
                        label={''}
                        source={'new_firm_id'}
                        validate={[required()]}
                        defaultValue={isEmpty(firmChoices) ? [] : firmChoices[0]}
                        choices={firmChoices}
                    />
                </Grid>
            </Grid>

            <NewFirmDetail label={'New Email address:'} source={'new_email'} validateFunction={[email()]}/>

            <Grid container direction={'row'} alignContent={'center'}>
                <Grid item xs={12} sm={6} md={2}>
                    <Typography>Date joined new firm:*</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormDateInput
                        label={''}
                        source={'date_adviser_joined_firm'}
                        validate={[required('Required')]}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

const NewFirmDetail = ({ label, source, validateFunction, ...rest }) => {
    const classes = useStyles();
    return (
        <Grid container direction={'row'} alignContent={'center'}>
            <Grid item xs={12} sm={6} md={2}>
                <Typography>{label}</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <FormTextInput label={''} source={source} validate={validateFunction} {...rest}/>
            </Grid>
        </Grid>
    );
};

const LoadingCircularProgress = ({ loading }) => {
    const classes = useStyles();

    if (!loading) {
        return null;
    }
    return (
        <div className={classes.circularProgressContainer}>
            <CircularProgress
                className={classes.circularProgress}
                size={25}
            />
        </div>
    );
};